import { Tabs } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { voucherPageModel, VoucherPageTabValues } from '../../model';
import { VoucherPageInfo } from '../voucher-page-info';
import { VoucherPagePromocode } from '../voucher-page-promocode';
import cls from './voucher-page-tabs.module.scss';

export const VoucherPageTabs = () => {
	const { t } = useTranslation();

	const [currentTab, setCurrentTab] = useUnit([
		voucherPageModel.$currentTab,
		voucherPageModel.changeTab,
	]);

	return (
		<Tabs
			variant='default'
			defaultValue='info'
			keepMounted={false}
			classNames={{
				root: cls.voucherPageTabs,
				tab: cls.voucherPageTabsTab,
				panel: cls.voucherPageTabsPanel,
			}}
			value={currentTab}
			onChange={(tab) => setCurrentTab(tab as VoucherPageTabValues)}
		>
			<Tabs.List>
				<Tabs.Tab
					data-test-id='voucher-page-info-tab'
					value='info'
				>
					{t('voucher-page.info')}
				</Tabs.Tab>
				<Tabs.Tab
					data-test-id='voucher-page-promocode-tab'
					value='promocode'
				>
					{t('voucher-page.promocode')}
				</Tabs.Tab>
			</Tabs.List>
			<Tabs.Panel value='info'>
				<VoucherPageInfo />
			</Tabs.Panel>
			<Tabs.Panel value='promocode'>
				<VoucherPagePromocode />
			</Tabs.Panel>
		</Tabs>
	);
};
